import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { SubAccountType } from "../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProductsValuationDetailSummary } from "../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";

import { ProductDetailsDispatcher } from "./Variable";

export interface ProductDetailsStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    detailsSummary?: ProductsValuationDetailSummary;
}

export class ProductDetailsStoreStatic extends BaseStore<ProductDetailsStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ProductDetailsDispatcher, (actionData) =>
            this.onProductDetailsStoreResponse(actionData)
        );
    }

    public getLastResult(): ProductDetailsStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ProductDetailsStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getProductDetails(): ProductsValuationDetailSummary {
        return this.getState().detailsSummary;
    }

    public getSubAccount(productType: SubAccountType) {
        const details = this.getState().detailsSummary;
        let account = null;
        if (details && details.Products) {
            const result = details.Products.filter((x) => x.ProductType == productType);
            if (result.length > 0) {
                account = result[0];
            }
        }
        return account;
    }

    private onProductDetailsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    detailsSummary: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
